import { ChangeDetectorRef, Component } from "@angular/core";
import {
  AuditPermissionService,
  Country as TypeOfChanges,
} from "@core/services/audit-permission.service";
import {
  FilterConfigType,
  TableColumn,
  TableComponent,
} from "@shared/components/table/table.component";
import { LazyLoadEvent } from "primeng/api";
import { LoaderService } from "@core/services/gigya/loader/loader.service";
import { finalize } from "rxjs";
import { AddTypeOfChangesComponent } from "./add-type-of-changes/add-type-of-changes.component";

@Component({
  selector: "app-type-of-changes",
  imports: [TableComponent, AddTypeOfChangesComponent],
  templateUrl: "./type-of-changes.component.html",
  styleUrl: "./type-of-changes.component.scss",
})
export class TypeOfChangesComponent {
  typeOfChangesData: TypeOfChanges[] = [];
  typeOfChangesColumns: TableColumn[] = [];
  typeOfChangesGlobalFilterFields: string[] = [];
  typeOfChangesFiltersConfig: FilterConfigType[] = [];
  typeOfChangesFiltersValue: { [key: string]: any } = {};
  openModal: boolean = false;

  typeOfChangesActions: any[] = [];

  typeOfChangesTotalRecords: number = 0;
  typeOfChangesLoading: boolean = false;
  typeOfChangesPage: number = 1;
  typeOfChangesPageSize: number = 10;
  typeOfChangesLastLazyLoadEvent: LazyLoadEvent | null = null;
  editData: any;
  editMode: boolean = false;
  constructor(
    private auditServices: AuditPermissionService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService
  ) {}
  ngOnInit(): void {
    this.setTabConfig();
    this.getTypeOfChanges();
  }

  setTabConfig(): void {
    this.typeOfChangesColumns = [
      { field: "sno", header: "S.No", sortable: false, width: "5%" },
      {
        field: "category_name",
        header: "Category",
        sortable: false,
        width: "10%",
      },
      {
        field: "name",
        header: "Type of Changes",
        sortable: false,
        filterable: false,
        width: "10%",
      },
      {
        field: "type_of_changes_name",
        header: "",
        isAction: true,
      },
    ];

    this.typeOfChangesActions = [
      {
        label: "Edit",
        class: "edit-button",
        onClick: (row: any) => this.editUser(row),
      },
    ];
  }

  editUser(row: any) {
    this.editData = row;
    this.editMode = true;
    this.openModal = true;
  }
  onLazyLoadEventFromTable(event: LazyLoadEvent) {
    this.typeOfChangesLastLazyLoadEvent = event;
    this.typeOfChangesLoading = true;
    this.loaderService.show();
    const currentEvent = event ||
      this.typeOfChangesLastLazyLoadEvent || {
        first: 0,
        rows: this.typeOfChangesPageSize,
      };

    this.typeOfChangesPage =
      (currentEvent.first ?? 0) /
        (currentEvent.rows ?? this.typeOfChangesPageSize) +
      1;
    this.typeOfChangesPageSize =
      currentEvent.rows ?? this.typeOfChangesPageSize;
    this.getTypeOfChanges();
  }

  getTypeOfChanges() {
    this.auditServices
      .getTypeOfChanges(this.typeOfChangesPage, this.typeOfChangesPageSize)
      .pipe(
        finalize(() => {
          this.typeOfChangesLoading = false;
          this.loaderService.hide();
        })
      )
      .subscribe({
        next: (response: any) => {
          this.typeOfChangesData = response?.change_types?.map(
            (item: any, index: any) => ({
              ...item,
              sno:
                (this.typeOfChangesPage - 1) * this.typeOfChangesPageSize +
                index +
                1,
              category_name: item.category.name,
            })
          );
          this.typeOfChangesTotalRecords = response?.meta.total;
          this.cdr.detectChanges();
        },
        error: (error) => {},
      });
  }
  Add() {
    this.openModal = true;
  }
  closeDialog(event: any) {
    this.openModal = false;
    this.editMode = false;
    this.getTypeOfChanges();
  }
}
